import {
  AfterViewInit,
  Component,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { ToastService } from './services/toast.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements AfterViewInit {
  title = 'practical-circle';

  @ViewChild('toastContainer', { read: ViewContainerRef })
  vcr!: ViewContainerRef;

  constructor(private toastService: ToastService) {}

  ngAfterViewInit(): void {
    this.toastService.registerViewContainerRef(this.vcr);
  }
}
